import { config } from '@/config';
import { useIsExtension } from '@/features/magic/hooks/useIsExtension';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

/** Whether Sign in with Apple should be offered on the web. */
export const useIsAppleLoginEnabled = (): boolean => {
  const { value } = useFeatureFlag('appleLoginEnabled');
  const { isExtension } = useIsExtension();
  return Boolean(value) && !isExtension && Boolean(config.appleAuth.clientId);
};
